import { createElement, installComponent } from '../utils/createElement';

export default class SideNavBody extends HTMLElement {
  constructor() {
    super();

    this.offset = 0;
    // eslint-disable-next-line no-underscore-dangle
    this._links = [];

    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    const slot = createElement('slot', {});

    const styles = createElement('style', null, '');

    this.shadowRoot.append(slot, styles);
  }

  _applyAnimation(menu, expand) {
    const heightToAdd = menu.expandedHeight;
    const sign = expand ? 1 : -1;

    // eslint-disable-next-line no-underscore-dangle
    const index = this._links.findIndex((m) => m === menu);
    // eslint-disable-next-line no-underscore-dangle, no-plusplus
    for (let i = index + 1; i < this._links.length; i++) {
      // eslint-disable-next-line no-underscore-dangle
      const currentMenuItem = this._links[i];
      const { root } = currentMenuItem;
      const newTransform = currentMenuItem.transform + (sign * heightToAdd);
      root.style.transform = `translateY(${newTransform}px)`;
      currentMenuItem.transform = newTransform;
    }
  }

  _orientItem(item) {
    // eslint-disable-next-line no-underscore-dangle
    this._links.push(item);
    // eslint-disable-next-line no-param-reassign
    item.transform = this.offset;
    // item.root.style.transform = `translateY(${item.transform}px)`
    // this.offset += item.collapsedHeight
    item.root.classList.add('sb-sidenav-link__placement');
    item.root.classList.add('sb-sidenav-link--root');
  }
}
installComponent('sb-sidenav-body', SideNavBody);
